import { createRequestActionTypes, createActionType } from '../../helpers'

export const FETCH_TUTORIAL_LIST = createRequestActionTypes(
  'TUTORIALS',
  'TUTORIAL_LIST'
)
export const FETCH_TUTORIAL_STEPS = createRequestActionTypes(
  'TUTORIALS',
  'TUTORIAL_STEPS'
)
export const UPDATE_STEP = createActionType('TUTORIALS', 'UPDATE_STEP')
export const UPDATE_STEP_NB = createActionType('TUTORIALS', 'UPDATE_STEP_NB')
export const ANIMATE_STEP = createActionType('TUTORIALS', 'ANIMATE_STEP')
export const ANIMATE_ALL = createActionType('TUTORIALS', 'ANIMATE_ALL')
export const ANIMATE_ALL_TERM = createActionType(
  'TUTORIALS',
  'ANIMATE_ALL_TERM'
)
export const UPDATE_FRAME = createActionType('TUTORIALS', 'UPDATE_FRAME')
export const AUTO_STEP = createActionType('TUTORIALS', 'AUTO_STEP')



// WEBPACK FOOTER //
// ./src/containers/Tutorials/constants.js